import { defineMessages } from 'react-intl';

export const trialSourceControlBannerMessages = defineMessages({
  title: {
    defaultMessage: 'Try source control while on your free trial', id: 'sxw3k4LpMm',
    description: 'Heading on the trial banner encouraging source control',
  },
  description: {
    defaultMessage:
      'Choose which trusted guidelines and research inform your answers', id: 'z66w84cpM0',
    description: 'Body copy on the trial source control banner',
  },
  tryNow: {
    defaultMessage: 'Try now', id: 'TmprBNF6Lm',
    description: 'Primary action on the trial source control banner',
  },
  closeAriaLabel: {
    defaultMessage: 'Close', id: 'YnDaXyTGlH',
    description: 'Accessible label for dismissing the trial source control banner',
  },
});
